var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-alerts"},_vm._l((_vm.alerts),function(alert,key){return _c('b-alert',{key:key,staticClass:"alert",attrs:{"show":"","dismissible":"","variant":alert.level},on:{"dismissed":function($event){return _vm.dismiss(alert.message)}}},[_vm._v(" "+_vm._s(alert.message)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }